import { createInertiaApp } from "@inertiajs/react"

import { initializeTheme } from "@/hooks/use-appearance"
import PersistentLayout from "@/layouts/persistent-layout"

const appName = import.meta.env.VITE_APP_NAME ?? "bookmockuptool"
const debugMode = new URLSearchParams(window.location.search).has("debug")

void createInertiaApp({
  // Set default page title
  // see https://inertia-rails.dev/guide/title-and-meta
  //
  title: (title) => (title ? `${title} - ${appName}` : appName),

  pages: "../pages",

  layout: () => [PersistentLayout],

  strictMode: !debugMode,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
  },

  progress: {
    color: "#4B5563",
  },
})
  .then(() => {
    window.requestAnimationFrame(() => {
      document.getElementById("bookmock-boot-splash")?.remove()
    })
  })
  .catch((error) => {
    // This ensures this entrypoint is only loaded on Inertia pages
    // by checking for the presence of the root element (#app by default).
    // Feel free to remove this `catch` if you don't need it.
    if (document.getElementById("app")) {
      throw error
    } else {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.',
      )
    }
  })

// This will set light / dark mode on load...
if (typeof localStorage !== "undefined") {
  initializeTheme()
}
